import React, { useContext, useEffect, useState } from "react";
import {
  Col,
  Row,
  Form,
  Button,
  Image,
  Card,
  Container,
  Badge,
  Alert,
} from "react-bootstrap";
import {
  faAngleRight, faCheckCircle, faDownload, faEye, faPencil, faSave,
  // faFileUpload,
  // faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "axios";
import { UploadService } from "../../../../services/upload.service";
import { toast } from "react-toastify";
import MyUploader from "../../../../components/Dropzone/dropzone";
import CenterService from "../../../../services/center.service";
import PreviewModal from "../../../../modal/Preview.modal";
import ExtensionHelper from "../../../../helpers/ExtensionHelper";


interface ICenterDocument {
  gstCerifiacte: string,
  // otherRegistrationNumber: string
  organizationRegistrationCertificate: string,
  aadharFront: string,
  aadharBack: string,
  pan: string,
  cancelChecque: string,
  centerAgreement: string,
}

const label = {
  margin: "0px",
  fontSize: "12px",
  padding: "0px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const imageExtention = ["jpg", "jpeg", "png"];

function CenterDocument() {
  const [showPreviewModal, setPreviewModal] = useState<any>(undefined);
  const [editEnabled, setEditEnabled] = useState<boolean>(false);
  const [centerDocumentData, setCenterDocumentData] = useState<ICenterDocument>({
    gstCerifiacte: "",
    organizationRegistrationCertificate: "",
    aadharFront: "",
    aadharBack: "",
    pan: "",
    cancelChecque: "",
    centerAgreement: "",
    // otherRegistrationNumber: ""
  })

  const fileSelectedHandler = async (e: any, name: string) => {
    const fd = new FormData();
    // let arr=[];
    for (let i of e) {
      fd.append("upload", i);
    }
    await UploadService.uploadFileToS3(fd).then((res: any) => {
      if (res.status === 200) {
        let centerData = res.data && res.data[0];
        setCenterDocumentData({ ...centerDocumentData, [name]: centerData })
        toast.success(`File(s) uploaded`);
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  const getCenterDetails = async () => {
    await CenterService.getCenterDocs()
      .then((res) => {
        console.log(res.data, "docs")
        setCenterDocumentData(res.data);
      })
      .catch((error) => {
      });
  };

  const updateCenterDocs = async () => {
    await CenterService.updateCenterDocs(centerDocumentData).then((res) => {
      if (res.status === 200) {
        toast.success("Data updated successfully.");
        getCenterDetails();
        setEditEnabled(false);
      }
    }).catch(err => {
      toast.error(err.response.data.message)
    })
  }

  const renderCertificate = (certificateName: any, filePath: any, uploadLabelName: string, isMandatory: boolean, col?: number) => {
    return (
      <Row>
        <Col md={col || 12}>
          <Card className="xcn-card mt-3">
            <Card.Body>
              <Row>
                <Col md={3}>
                  <div className="fw-bold h6 text-secondary d-flex justify-content-start align-items-center">
                    <div>
                      {certificateName}
                    </div>
                    <div>
                      {isMandatory && <Badge bg="danger" className="ms-1 xcn-text-8">required</Badge>}
                    </div>
                  </div>


                </Col>
                <Col md={5}>
                  <h3 className="text-primary text-decoration-none xcn-text-12">
                    {
                      filePath && <div className="d-flex justify-content-start align-items-center">
                        <FontAwesomeIcon icon={faCheckCircle} className="me-1 text-success" /> File Already Uploaded click here to
                        {
                          ExtensionHelper.isPdf(filePath) ?
                            <div className="ms-1">
                              <span className="text-success text-decoration-none xcn-link-pointer" onClick={() => openPDF(filePath)}>View/Download <FontAwesomeIcon icon={faDownload} /></span>
                            </div> :
                            <div className="ms-1">
                              <a className=" text-success text-decoration-none xcn-link-pointer" href={filePath} download>View/Download <FontAwesomeIcon icon={faDownload} /></a>
                            </div>
                        }
                      </div>
                    }
                  </h3>
                  <MyUploader
                    fileSelectedHandler={(e: any) =>
                      fileSelectedHandler(e, uploadLabelName)
                    }
                  />
                </Col>
                <Col md={4}>
                  <Alert variant="warning" className="mt-2">
                    <div className="xcn-text-10 fw-bold">
                      Upload Instructions:
                    </div>
                    <div className="xcn-text-10">
                      1. Max allowed size is 5MB - PDF/IMAGE only
                    </div>
                    <div className="xcn-text-10">
                      2. Background of the Image should be white
                    </div>
                  </Alert>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    )
  }

  function openPDF(pdf: any) {
    window.open(pdf, "_blank");
  }


  useEffect(() => {
    getCenterDetails();
  }, [])



  return (
    <div>
      <PreviewModal
        show={showPreviewModal}
        setShow={setPreviewModal}
      />

      <Container className="">
        <>
          <div className="d-flex justify-content-end">
            <Button
              size="sm"
              variant="primary"
              className="my-4"
              onClick={updateCenterDocs}
            >
              {"Save"} <FontAwesomeIcon icon={faSave} />
            </Button>
          </div>
          {renderCertificate("GST Certificate", centerDocumentData?.gstCerifiacte, "gstCerifiacte", false)}
          {renderCertificate("Organization Registration Certificate", centerDocumentData?.organizationRegistrationCertificate, "organizationRegistrationCertificate", false)}
          {renderCertificate("Owner/Authorized Person Aadhar Copy Upload - Front", centerDocumentData?.aadharFront, "aadharFront", false)}
          {renderCertificate("Owner/Authorized Person Aadhar Copy Upload - Back", centerDocumentData?.aadharBack, "aadharBack", true)}
          {renderCertificate("Valid Pan Card Upload", centerDocumentData?.pan, "pan", true)}
          {renderCertificate("Cancelled Cheque", centerDocumentData?.cancelChecque, "cancelChecque", true)}
          {renderCertificate("Center Agreement", centerDocumentData?.centerAgreement, "centerAgreement", true)}

        </>
      </Container >
    </div >
  );
}

export default CenterDocument;
